import React from "react"
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Card, CardFooter, CardHeader, CardTitle, CardContent, CardDescription, CardAction, Button, Label, Input } from '../../shadcnComponents/ui'

export function RenameGroupInput(props) {
    function handleRename() {
        if (document.getElementById("new-name").value != "") {
            props.rename();
            document.getElementById('new-name').value = '';
            document.getElementById('new-name').required = false
        } else {
            document.getElementById("new-name").required = true
        }
    }

    function closeDialogue() {
        document.getElementById('new-name').value = '';
        document.getElementById('new-name').required = false
        document.getElementById('new-groupname').classList.add('hidden');
    }

    return (
        <div id='new-groupname' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    <CardTitle>Μετονομασία</CardTitle>
                    <CardDescription>
                        Δώστε ένα νέο όνομα για την ομάδα
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { closeDialogue() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent>
                    <form>
                        <div className="flex flex-col gap-6">
                            <div className="grid gap-2">
                                <Label htmlFor="text">Νέο όνομα</Label>
                                <Input
                                    id="new-name"
                                    type="text"
                                    placeholder={props.groupnameToRename}
                                />
                            </div>
                        </div>
                    </form>
                </CardContent>
                <CardFooter className='gap-5 w-full justify-end'>
                    <Button onClick={() => { handleRename() }} variant={'yes'} >
                        Μετονομασία
                    </Button>
                    <Button variant={'no'} onClick={() => { closeDialogue() }}>
                        Άκυρο
                    </Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default RenameGroupInput